import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { InfoTooltipComponent } from '@ui-kit/miscs/info-tooltip/info-tooltip.component';

@Component({
    selector: 'form-label',
    standalone: true,
    imports: [TranslateModule, InfoTooltipComponent],
    templateUrl: './form-label.component.html',
    styleUrl: './form-label.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormLabelComponent {
    id = input.required<string>();
    forId = input.required<string>();
    label = input.required<string>();

    required = input<boolean>(false);
    tooltipText = input<string>('');
    infoTooltipClass = input<string>('fa-regular fa-circle-question');
    hasError = input<boolean>(false);
    minWidth = input<string | null>(null);
}
